module.exports = __webpack_public_path__ + "static/media/ic_avatar.47c159e7.svg";